"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "folignano": {
    "dbfae5f8": [{
      "hkey": "0426b0db",
      "slug": "villa-pigna-case-di-coccia",
      "name": "Villa Pigna-Case di Coccia",
      "primary": true,
      "skipSearch": false
    }],
    "villa-pigna": [{
      "hkey": "0426b0db",
      "slug": "villa-pigna-case-di-coccia",
      "name": "Villa Pigna-Case di Coccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;